export const API_URL = process.env.REACT_APP_API_URL;

export const InputSearchDelay = 700;

export enum PermissionsLabel {
  READ = 'Чтение',
  EDIT = 'Запись',
  CREATE = 'Создание',
  NO = 'Недоступно',
}

export enum Entities {
  EVENT = 'EVENT',
  EVENTS = 'EVENTS',
  USER = 'USER',
  DEVICE = 'DEVICE',
  VEHICLE = 'VEHICLE',
  BINDINGS = 'BINDINGS',
  ROLES = 'ROLES',
  GROUP = 'GROUP',
  HISTORY = 'HISTORY',
  SERVICE_MODE = 'SERVICE_MODE',
  SYSTEM_DRIVER_ACCOUNT = 'SYSTEM_DRIVER_ACCOUNT',
  NOTIFICATIONS = 'NOTIFICATIONS',
  OPERATOR_CHATS = 'OPERATOR_CHATS',
}

export enum Permissions {
  PERMISSION_VEHICLE_READ = `PERMISSION_VEHICLE_READ`,
  PERMISSION_VEHICLE_CREATE = `PERMISSION_VEHICLE_CREATE`,
  PERMISSION_VEHICLE_EDIT = 'PERMISSION_VEHICLE_EDIT',
  PERMISSION_VEHICLE_DELETE = 'PERMISSION_VEHICLE_DELETE',

  PERMISSION_EVENTS_READ = 'PERMISSION_EVENTS_READ',
  PERMISSION_EVENTS_READ_ONLY_ROLE = 'PERMISSION_EVENTS_READ_ONLY_ROLE',

  SYSTEM_GLOBAL_ADMIN = 'SYSTEM_GLOBAL_ADMIN',

  PERMISSION_ROLES_READ = `PERMISSION_ROLES_READ`,
  PERMISSION_ROLES_CREATE = `PERMISSION_ROLES_CREATE`,
  PERMISSION_ROLES_EDIT = 'PERMISSION_ROLES_EDIT',
  PERMISSION_ROLES_DELETE = 'PERMISSION_ROLES_DELETE',

  PERMISSION_DEVICE_READ = `PERMISSION_DEVICE_READ`,
  PERMISSION_DEVICE_CREATE = `PERMISSION_DEVICE_CREATE`,
  PERMISSION_DEVICE_EDIT = 'PERMISSION_DEVICE_EDIT',
  PERMISSION_DEVICE_DELETE = 'PERMISSION_DEVICE_DELETE',

  PERMISSION_USER_CREATE = `PERMISSION_USER_CREATE`,
  PERMISSION_USER_READ = `PERMISSION_USER_READ`,
  PERMISSION_USER_EDIT = 'PERMISSION_USER_EDIT',
  PERMISSION_USER_DELETE = 'PERMISSION_USER_DELETE',

  PERMISSION_BINDINGS_CREATE = `PERMISSION_BINDINGS_CREATE`,
  PERMISSION_BINDINGS_READ = `PERMISSION_BINDINGS_READ`,
  PERMISSION_BINDINGS_EDIT = 'PERMISSION_BINDINGS_EDIT',
  PERMISSION_BINDINGS_DELETE = 'PERMISSION_BINDINGS_DELETE',

  SYSTEM_DRIVER_ACCOUNT = 'SYSTEM_DRIVER_ACCOUNT',
  SYSTEM_SERVICE_ACCOUNT = 'SYSTEM_SERVICE_ACCOUNT',

  PERMISSION_SERVICE_MODE_CREATE = 'PERMISSION_SERVICE_MODE_CREATE',
  PERMISSION_SERVICE_MODE_READ = 'PERMISSION_SERVICE_MODE_READ',
  PERMISSION_SERVICE_MODE_EDIT = 'PERMISSION_SERVICE_MODE_EDIT',
  PERMISSION_HISTORY_READ = 'PERMISSION_HISTORY_READ',
  PERMISSION_NOTIFICATIONS_EDIT = 'PERMISSION_NOTIFICATIONS_EDIT',
  PERMISSION_NOTIFICATIONS_DELETE = 'PERMISSION_NOTIFICATIONS_DELETE',
  PERMISSION_NOTIFICATIONS_READ = 'PERMISSION_NOTIFICATIONS_READ',
  PERMISSION_NOTIFICATIONS_CREATE = 'PERMISSION_NOTIFICATIONS_CREATE',

  PERMISSION_OPERATOR_CHATS_READ = 'PERMISSION_OPERATOR_CHATS_READ',
  PERMISSION_OPERATOR_CHATS_CREATE = 'PERMISSION_OPERATOR_CHATS_CREATE',
  PERMISSION_OPERATOR_CHATS_EDIT = 'PERMISSION_OPERATOR_CHATS_EDIT',
  PERMISSION_OPERATOR_CHATS_DELETE = 'PERMISSION_OPERATOR_CHATS_DELETE',
}

export enum PermissionsStatus {
  NO_PERMISSION,
  READ,
  EDIT,
  CREATE,
}
